module.exports = __webpack_public_path__ + "img/havefun_kansai_jp.92199608.png";